import { Routes } from '@angular/router';
import { authGuard, guestGuard } from './guards/auth.guard';

export const routes: Routes = [
  // Redirect root based on auth state
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

  // Public — redirect to dashboard if already logged in
  {
    path: 'auth',
    loadComponent: () => import('./components/auth/auth.component').then(m => m.AuthComponent),
    canActivate: [guestGuard],
  },

  // Protected portal routes
  {
    path: '',
    loadComponent: () => import('./app-shell.component').then(m => m.AppShellComponent),
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./components/dashboard/dashboard.component').then(m => m.DashboardComponent),
      },
      {
        path: 'explore',
        loadComponent: () => import('./components/explore/explore.component').then(m => m.ExploreComponent),
      },
      {
        path: 'donate',
        loadComponent: () => import('./components/donate/donate.component').then(m => m.DonateComponent),
      },
      {
        path: 'donations',
        loadComponent: () => import('./components/donation-history/donation-history.component').then(m => m.DonationHistoryComponent),
      },
      {
        path: 'subscriptions',
        loadComponent: () => import('./components/subscriptions/subscriptions.component').then(m => m.SubscriptionsComponent),
      },
      {
        path: 'statements',
        loadComponent: () => import('./components/statements/statements.component').then(m => m.StatementsComponent),
      },
      {
        path: 'profile',
        loadComponent: () => import('./components/profile/profile.component').then(m => m.ProfileComponent),
      },
    ],
  },

  // Fallback
  { path: '**', redirectTo: 'dashboard' },
];
